import { combineReducers } from 'redux';
import admin from './admin';
import inventory from './inventory';
import regular from './regular';
import sales from './sales';
import profiles from './profiles';

const reducers = combineReducers({
  admin,
  inventory,
  regular,
  sales,
  profiles
});

export default reducers;

export type RootState = ReturnType<typeof reducers>;
